import graphql__442e002c6e8d20cb26a2 from "./__generated__/ConfigurationAttributeDefinitionsViewQuery.graphql.ts";import * as React from "react";
import Panel from "./presentational/Panel";
import {connect, ConnectedProps} from "react-redux";
import {hideModal, showModal} from "../store/actions";
import {usePreloadedQuery} from "react-relay/hooks";
import {graphql} from "react-relay";
import {useOutletContext} from "react-router";
import {ConfigurationAttributeDefinitionsViewQuery} from "./__generated__/ConfigurationAttributeDefinitionsViewQuery.graphql";
import CreateAttributeDefinitionDialog from "./dialog/CreateAttributeDefinitionDialog";
import DeleteAttributeDefinitionDialog from "./dialog/DeleteAttributeDefinitionDialog";
import ActionButton from "./presentational/button/ActionButton";
import {faPlusCircle, faTrashCan} from "@fortawesome/pro-regular-svg-icons";
import TableHeader from "./presentational/table/TableHeader";
import Table from "./presentational/table/Table";
import TableData, {TextAlignment} from "./presentational/table/TableData";
import Headline from "./presentational/Headline";
import {useIntl} from "react-intl";

type Props = {}

const connector = connect(undefined, {
    dispatchShowModal: showModal,
    dispatchHideModal: hideModal
});

type ConfigurationAttributeDefinitionsViewProps = Props & ConnectedProps<typeof connector>;

const ConfigurationAttributeDefinitionsView: React.FC<ConfigurationAttributeDefinitionsViewProps> = (props) => {
    const intl = useIntl();
    const prepared: any = useOutletContext();
    const data = usePreloadedQuery<ConfigurationAttributeDefinitionsViewQuery>(
        graphql__442e002c6e8d20cb26a2,
        prepared.configurationAttributeDefinitionsViewQuery,
    );

    const {dispatchShowModal, dispatchHideModal} = props

    const showCreateAttributeDefinitionDialog = () => {
        dispatchShowModal({
            body: (<CreateAttributeDefinitionDialog handleCloseDialog={dispatchHideModal}/>)
        })
    };

    const showDeleteAttributeDefinitionDialog = (attributeDefinitionId: string, attributeName: string) => {
        dispatchShowModal({
            body: (<DeleteAttributeDefinitionDialog
                attributeDefinitionId={attributeDefinitionId}
                attributeName={attributeName}
                handleCloseDialog={dispatchHideModal}
            />)
        })
    };

    return (
        <Panel>
            <div className="px-6 pt-6 pb-4">
                <div className="md:flex md:items-center md:justify-between">
                    <div className="flex-1 min-w-0">
                        <Headline>{intl.formatMessage({id: 'view.configurationAttributeDefinitions.headline'})}</Headline>
                    </div>
                    <div className="mt-6 flex space-x-3 md:mt-0 md:ml-4">
                        <ActionButton icon={faPlusCircle} title={intl.formatMessage({id: 'view.configurationAttributeDefinitions.createButton'})} onClick={() => {
                            showCreateAttributeDefinitionDialog()
                        }}/>
                    </div>
                </div>
            </div>
            {data.attributeDefinitions?.edges && data.attributeDefinitions.edges.length > 0 ? (
                <div className="flex-1 min-h-0 relative overflow-y-auto" aria-label={intl.formatMessage({id: 'view.configurationAttributeDefinitions.ariaLabel'})}>
                    <Table>
                        <thead>
                            <tr>
                                <TableHeader>{intl.formatMessage({id: 'view.configurationAttributeDefinitions.table.name'})}</TableHeader>
                                <TableHeader>{intl.formatMessage({id: 'view.configurationAttributeDefinitions.table.label'})}</TableHeader>
                                <TableHeader>{intl.formatMessage({id: 'view.configurationAttributeDefinitions.table.type'})}</TableHeader>
                                <TableHeader>{intl.formatMessage({id: 'view.configurationAttributeDefinitions.table.entityTypes'})}</TableHeader>
                                <TableHeader className="hidden sm:table-cell"/>
                            </tr>
                        </thead>
                        <tbody>
                            {data.attributeDefinitions.edges.map((edge, index) => {
                                if (!edge?.node) {
                                    return null;
                                }
                                const {id, name, label, type, entityTypes} = edge.node;

                                return (
                                    <tr key={index} className={(index % 2 === 0 ? 'bg-white' : 'bg-gray-50') + ' hover:bg-gray-100 group'}>
                                        <TableData>
                                            <span className="font-mono text-sm">{name}</span>
                                        </TableData>
                                        <TableData>{label}</TableData>
                                        <TableData>
                                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                                {type}
                                            </span>
                                        </TableData>
                                        <TableData>
                                            {entityTypes.map((entityType, idx) => (
                                                <span key={idx} className="inline-flex items-center px-2 py-1 rounded-sm text-xs font-medium bg-green-100 text-green-800 mr-1">
                                                    {entityType}
                                                </span>
                                            ))}
                                        </TableData>
                                        <TableData textAlignment={TextAlignment.Right}>
                                            <ActionButton
                                                additionalClassname="invisible group-hover:visible"
                                                icon={faTrashCan}
                                                title={intl.formatMessage({id: 'attributeDefinition.deleteButton'})}
                                                onClick={() => showDeleteAttributeDefinitionDialog(id, name)}
                                            />
                                        </TableData>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                </div>
            ) : (
                <div className="text-center py-10">
                    <p className="text-gray-500">{intl.formatMessage({id: 'view.configurationAttributeDefinitions.noDefinitions'})}</p>
                </div>
            )}
        </Panel>
    )
}

export default connector(ConfigurationAttributeDefinitionsView);
